import CompanyMemberActionsCellRenderer from '@companies/components/cell-renderers/CompanyMemberActionsCellRenderer.vue'
import CompanyMemberApplicationAccess from '@companies/components/cell-renderers/CompanyMemberApplicationAccess.vue'

const defaultColDef = {
  menuTabs: [
    'filterMenuTab',
    'generalMenuTab',
    'columnsMenuTab',
  ],
  resizable: true,
  sortable: true,
  filter: true,
}

const columnDefs = [
  {
    field: 'id',
    hide: true,
    sortable: true,
  },
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    width: 60,
  },
  {
    headerName: 'Email',
    field: 'email',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'Role',
    field: 'type',
    cellRenderer: 'BadgeCellRenderer',
    cellRendererParams: {
      'variant': {
        admin: 'primary',
        member: 'secondary',
      },
    },
    minWidth: 100,
    sortable: false,
  },
  {
    headerName: 'Application Access',
    field: 'applicationAssociation',
    cellRenderer: CompanyMemberApplicationAccess,
    minWidth: 120,
    sortable: false,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: 'BadgeCellRenderer',
    cellRendererParams: {
      'variant': {
        APPROVED: 'success',
        DISABLED: 'danger',
        PENDING: 'warning',
      },
    },
    minWidth: 100,
    enableCellChangeFlash: true,
    sortable: false,
  },
  {
    headerName: 'Actions',
    field: 'status',
    cellRenderer: CompanyMemberActionsCellRenderer,
    filter: false,
    sortable: false,
    minWidth: 200,
    suppressHeaderMenuButton: true,
    enableCellChangeFlash: true,
  },
]

export const gridConfig = {
  defaultColDef,
  columnDefs,
  statusBar: {},
  pagination: true,

  apiSettings: { noRowsMessage: 'No company members found' },
  enableExportButton: true,
  enableMultirowSelect: false,
  enablePresets: false,
  enableQuickFilter: false,
  showActiveFilters: true,
}
